import local from "./local.ts";
import toUI from "./toUI.ts";
import type { Conditions, PartialTopMenu } from "../../common/types.ts";

// Icons fork: no external account server.
//
// Upstream, this called account.basketball-gm.com/user_info.php on boot to
// check login / ZenGM Gold status and to sync achievements. We don't run that
// service, so we always report a logged-out account with Gold effectively
// granted (goldUntil: Infinity) — which is what the upstream error path did
// anyway when the account server was unreachable, and it keeps ZenGM's ads off.
export const checkAccount = async (
	_conditions: Conditions,
): Promise<PartialTopMenu> => {
	local.goldUntil = Infinity;
	local.mailingList = false;
	local.email = undefined;
	local.username = undefined;

	await toUI("updateLocal", [
		{
			email: undefined,
			gold: true,
			username: undefined,
		},
	]);

	return {
		email: "",
		goldCancelled: false,
		goldUntil: Infinity,
		username: "",
		mailingList: false,
	};
};
